// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetAppSystemCustomFieldsRequestModel from '../../model/get-app-system-custom-fields-request-model';
import GetAppSystemCustomFieldsRequestDTO from '../dto/get-app-system-custom-fields-request-dto';
import dtoSchema from '../schemas/get-app-system-custom-fields-request-schema';

export default abstract class GetAppSystemCustomFieldsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetAppSystemCustomFieldsRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetAppSystemCustomFieldsRequestDTO>): GetAppSystemCustomFieldsRequestModel;
  static toModel(dto: DeepPartial<GetAppSystemCustomFieldsRequestDTO> | undefined | null): GetAppSystemCustomFieldsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetAppSystemCustomFieldsRequestDTO> | undefined | null): GetAppSystemCustomFieldsRequestModel | undefined {
    return dto ? new GetAppSystemCustomFieldsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetAppSystemCustomFieldsRequestModel> | GetAppSystemCustomFieldsRequestModel): GetAppSystemCustomFieldsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetAppSystemCustomFieldsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetAppSystemCustomFieldsRequestModel, can not map to GetAppSystemCustomFieldsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
